import React from "react";
import PropTypes from "prop-types";
import { Box, Typography, Button, Paper, List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { Icon } from "@iconify/react";

function WelcomeStep({ onNext, onSkip }) {
  return (
    <Box sx={{ textAlign: "center", maxWidth: 800, mx: "auto" }}>
      <Icon icon="mdi:hand-wave" width={64} color="primary" />

      <Typography variant="h4" gutterBottom sx={{ mt: 2, fontWeight: "bold" }}>
        Willkommen beim Datenimport-Assistenten
      </Typography>

      <Typography variant="h6" color="text.secondary" paragraph>
        Dieser Assistent hilft Ihnen dabei, Ihre bestehenden Daten aus anderen Systemen
        in die Martial Artministration zu übertragen.
      </Typography>

      <Paper elevation={1} sx={{ p: 3, mt: 4, textAlign: "left" }}>
        <Typography variant="h6" gutterBottom fontWeight="bold">
          Was können Sie importieren?
        </Typography>
        <List>
          <ListItem>
            <ListItemIcon>
              <Icon icon="mdi:map-marker" width={24} color="primary" />
            </ListItemIcon>
            <ListItemText
              primary="Standorte"
              secondary="Trainingsorte mit allen Details und Einstellungen"
            />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <Icon icon="mdi:account-group" width={24} color="primary" />
            </ListItemIcon>
            <ListItemText
              primary="Mitglieder"
              secondary="Alle Mitgliederdaten inklusive Kontaktinformationen und Gürtelgrade"
            />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <Icon icon="mdi:file-document" width={24} color="primary" />
            </ListItemIcon>
            <ListItemText
              primary="Verträge"
              secondary="Vertragsnehmer mit Bankdaten (sicher verschlüsselt)"
            />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <Icon icon="mdi:calendar" width={24} color="primary" />
            </ListItemIcon>
            <ListItemText
              primary="Veranstaltungen & Buchungen (optional)"
              secondary="Historische Daten zu Events und Abrechnungen"
            />
          </ListItem>
        </List>
      </Paper>

      <Paper elevation={1} sx={{ p: 3, mt: 3, textAlign: "left", bgcolor: "info.lighter" }}>
        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
          <Icon icon="mdi:information" width={24} />
          <Box>
            <Typography variant="body1" fontWeight="bold" gutterBottom>
              Wichtig zu wissen:
            </Typography>
            <Typography variant="body2">
              • Ihre Daten werden vor dem Import überprüft und validiert<br />
              • Sie können alle Daten vor dem finalen Import noch einmal überprüfen und bearbeiten<br />
              • Der Import kann mehrere Minuten dauern, je nach Datenmenge<br />
              • Unterstützte Formate: CSV (Excel), Legacy JSON
            </Typography>
          </Box>
        </Box>
      </Paper>

      <Box sx={{ mt: 4, display: "flex", gap: 2, justifyContent: "center" }}>
        <Button
          variant="outlined"
          size="large"
          onClick={onSkip}
          startIcon={<Icon icon="mdi:skip-next" />}
        >
          Später importieren
        </Button>
        <Button
          variant="contained"
          size="large"
          onClick={onNext}
          endIcon={<Icon icon="mdi:arrow-right" />}
        >
          Jetzt starten
        </Button>
      </Box>
    </Box>
  );
}

WelcomeStep.propTypes = {
  onNext: PropTypes.func.isRequired,
  onSkip: PropTypes.func.isRequired,
};

export default WelcomeStep;
